import React from 'react';
import { useMenu } from 'hooks';
import {
	IconButton,
	Menu,
	MenuItem,
	Checkbox,
	Box,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { Image, Label } from 'components';
import { MoreHoriz } from '@mui/icons-material';

const VideoItem = ({
	video,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(video, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(video, e)}>Delete</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(video.id);

	return (
		<TableRow hover sx={{ cursor: 'pointer' }}>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected}
						onChange={() => handleSelect(video)}
						name="video"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell>
				<Box
					onClick={() => handleClick(video)}
					sx={{
						display: 'inline-block',
						'&:hover': {
							opacity: 0.8
						}
					}}
				>
					<Image src={video.image_url} variant="rounded" size={80} />
				</Box>
			</TableCell>
			<TableCell>
				<Typography
					variant="body2"
					color="text.primary"
					onClick={() => handleClick(video)}
					sx={{
						cursor: 'pointer',
						'&:hover': {
							textDecoration: 'underline'
						}
					}}
				>
					{video?.user?.name}
				</Typography>
			</TableCell>
			<TableCell>
				<Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
					{video?.tags?.map((label, i) => (
						<Label key={i} label={label} />
					))}
				</Box>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
					{renderMenu()}
				</IconButton>
			</TableCell>
		</TableRow>
	);
};

export default VideoItem;
